import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

// A plain static asset fetch, not an API call — the manual is bundled into
// public/manuals/ (see angular.json's assets config), not served by the
// backend, so this deliberately doesn't go through environment.apiUrl.
@Injectable({ providedIn: 'root' })
export class PartnerManualService {
  constructor(private http: HttpClient) {}

  getManual(): Observable<string> {
    return this.http.get('/manuals/partner-portal-manual.html', { responseType: 'text' });
  }
}
